import { useState } from 'react';
import { ExecutionHistoryContextType } from './context';
import { ExecutionHistory } from 'pages/AutomationEngine/types';

export const useExecutionHistoryContext = (): ExecutionHistoryContextType => {
  const [historyId, setHistoryId] = useState<string | null>(null);

  const [showHistorySideBar, setShowHistorySideBar] = useState<boolean>(true);

  const [orderedExecutionHistory, setOrderedExecutionHistory] = useState<
    ExecutionHistory[]
  >([]);

  const [selectedHistoryStepIndex, setSelectedHistoryStepIndex] =
    useState<number>(0);

  const getSelectedHistoryStep = () =>
    orderedExecutionHistory[selectedHistoryStepIndex || 0];

  return {
    historyId,
    showHistorySideBar,
    orderedExecutionHistory,
    selectedHistoryStepIndex,
    setHistoryId,
    setShowHistorySideBar,
    setOrderedExecutionHistory,
    setSelectedHistoryStepIndex,
    getSelectedHistoryStep,
  };
};
